module.exports = __webpack_public_path__ + "stylesheets/global_d14f12f7af235eec61965c757699604a.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/global.less
// module id = x7Q4
// module chunks = 55